module.exports = __webpack_public_path__ + "img/google_play.c6db884b.png";